
export const getImageUrl = (imageName: string): string => {
  return require(`../assets/${imageName}`);
};

export const getImageBase64 = (url: string) : Promise<string> =>{
  return new Promise((resolve, reject) =>{
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = url
    img.onload = () =>{
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(img,0,0)
      const dataUrl = canvas.toDataURL('image/png')
      resolve(dataUrl)
    }
    img.onerror = (err) => reject(err)
  })
}